/**
 * Traduz erros retornados pela API do Caderno LPMA para mensagens
 * amigáveis ao usuário, sem expor o texto bruto do back-end.
 */
export const traduzirErroCadernoLPMA = (error: any): string => {
	const status: number | undefined = error?.response?.status;
	const data = error?.response?.data;
	const mensagemBackend: string =
		(typeof data === 'string' ? data : data?.message) ?? error?.message ?? '';

	if (status === 403 || /sem permiss/i.test(mensagemBackend)) {
		if (/dados principais/i.test(mensagemBackend)) {
			return 'Você não tem permissão para alterar os dados principais do caderno. Salve apenas as demais seções ou peça a alteração a um administrador.';
		}
		if (/criar/i.test(mensagemBackend)) {
			return 'Você não tem permissão para criar cadernos. Solicite o acesso ao administrador do sistema.';
		}
		return 'Você não tem permissão para salvar as alterações deste caderno.';
	}

	if (status === 401) {
		return 'Sua sessão expirou. Entre novamente para continuar.';
	}

	if (status === 404) {
		return 'Caderno não encontrado. Ele pode ter sido removido por outro usuário.';
	}

	if (status === 400) {
		return 'Não foi possível salvar o caderno. Revise os campos preenchidos e tente novamente.';
	}

	if (!error?.response) {
		return 'Não foi possível se comunicar com o servidor. Verifique sua conexão e tente novamente.';
	}

	return 'Ocorreu um erro inesperado ao salvar o caderno. Tente novamente em instantes.';
};
